// This component includes both virtual and in-person appointment buttons
import Image from 'next/image'
import computer from './computer.svg'
import calendar from './calendar.svg'
import InteractiveViewIcon from './InteractiveViewIcon.svg'
import TryOnHandIcon from './TryOnHandIcon.svg'
import cn from 'clsx'
import { AlertContext } from 'context/alertContext'
import { useContext } from 'react'
import { Button } from '@components/ui'
import s from './AppointmentButtons.module.css'
import {
  Calendar,
  Computer,
  InteractiveView,
  TryOnHand,
} from '@components/yadav/icons'

interface AppointmentButtonProps {
  variant: 'virtual' | 'person' | 'inova'
  className?: string
  idInova?: string
  hidden?: boolean
}

const AppointmentButtons = ({
  variant,
  className,
  idInova,
  hidden,
}: AppointmentButtonProps) => {
  const { setShowMessage } = useContext(AlertContext)

  const label =
    variant === 'virtual'
      ? 'Book a Virtual Consultation'
      : variant === 'person'
      ? 'Book an In-Person Appointment'
      : variant === 'inova' && idInova === 'try_vto_4'
      ? 'Virtual Ring Try On'
      : 'Interactive View'
  const href =
    variant === 'virtual'
      ? '/virtual-consultation'
      : '/jewelry-store-san-francisco'

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    if (typeof window !== 'undefined') {
      if (variant === 'inova') {
        try {
          if (idInova === 'try_vto_4') {
            window.cls_InovaDiamonds_Iframe.Inova__OpenFrame()
          } else {
            window.cls_InovaDiamonds_Iframe.Inova__OpenFrame('m3d')
          }
        } catch (error) {
          setShowMessage({
            show: true,
            message:
              'An error occurred when opening the virtual ring tool. Please try again later.',
            type: 'Error',
          })
        }
      } else {
        window.open(href, '_blank')
      }
    }
  }

  return (
    <Button
      id={variant === 'inova' ? idInova : ''}
      className={cn(s.btn, className, { [s.hide]: hidden })}
      aria-label={label}
      onClick={(e) => handleOpen(e)}
      variant="type1"
      width="100%"
    >
      <div className="flex items-center gap-3">
        {variant === 'inova' && idInova === 'try_vto_3' && <InteractiveView />}
        {variant === 'inova' && idInova === 'try_vto_4' && <TryOnHand />}
        {variant === 'virtual' && <Computer />}
        {variant === 'person' && <Calendar />}
        <span>{label}</span>
      </div>
    </Button>
  )
}

export default AppointmentButtons
